var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSettings(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Vrstva_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    width: "24px",
    height: "24px",
    viewBox: "0 0 24 24",
    enableBackground: "new 0 0 24 24",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "ico_x2F_nastaveni"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M22.7,19l-9.1-9.1C14.5,7.6,14,4.9,12.101,3c-2-2-5-2.4-7.4-1.3L9,6L6,9l-4.4-4.3c-1.2,2.4-0.7,5.4,1.3,7.4 c1.9,1.9,4.6,2.4,6.9,1.5l9.1,9.101c0.4,0.399,1,0.399,1.4,0l2.3-2.3C23.101,20,23.101,19.3,22.7,19z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSettings);
export default __webpack_public_path__ + "static/media/settings.7316d6d94ca64837fa7623b7de637788.svg";
export { ForwardRef as ReactComponent };